import * as React from 'react';

import { Badge, Button } from '@rematter/ui-web';
import { LucideX } from 'lucide-react';

import { OPERATION_TYPE_COLORS } from '~/modules/pricing/types/pricing';

type GroupOption = {
  id: string;
  name: string;
  operationType: string;
};

type SelectCounterpartyGroupProps = {
  groups: GroupOption[];
  onSelect: (groupId: string) => void;
  onCancel: () => void;
};

export const SelectCounterpartyGroup = ({
  groups,
  onSelect,
  onCancel,
}: SelectCounterpartyGroupProps) => {
  const [searchTerm, setSearchTerm] = React.useState('');

  const filteredGroups = React.useMemo(
    () =>
      groups.filter((g) =>
        g.name.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    [groups, searchTerm],
  );

  return (
    <div className="@SelectCounterpartyGroup flex w-full flex-col gap-1">
      <div className="flex items-center gap-2">
        <input
          type="text"
          autoFocus
          className="flex-1 rounded border border-neutral/30 px-3 py-1.5 text-sm focus:border-primary focus:outline-none"
          placeholder="Search groups..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Button
          variant="ghost"
          color="neutral"
          size="small"
          icon={<LucideX size={14} />}
          onPress={onCancel}
        />
      </div>
      <div className="max-h-40 overflow-y-auto rounded border border-neutral/20 bg-white">
        {filteredGroups.length === 0 ? (
          <div className="px-3 py-2 text-sm text-neutral/50">
            No groups available
          </div>
        ) : (
          filteredGroups.map((group) => (
            <button
              key={group.id}
              type="button"
              className="flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm hover:bg-neutral/5"
              onClick={() => onSelect(group.id)}
            >
              <span>{group.name}</span>
              <Badge
                color={
                  OPERATION_TYPE_COLORS[
                    group.operationType as keyof typeof OPERATION_TYPE_COLORS
                  ]
                }
                size="small"
              >
                {group.operationType}
              </Badge>
            </button>
          ))
        )}
      </div>
    </div>
  );
};
